import { accountSelector } from './accountSelector';
import { accountSelected } from './accountsSelected';
import { authenticatorFooter } from './authenticatorFooter';
import { availableAccountList } from './availableAccountList';
import { bankDocument } from './bankDocument';
import { cloudwareDocumentDisclaimer } from './cloudwareDisclaimerDoc';
import { cloudwareDocument } from './cloudwareDocument';
import { costSummary } from './costSummary';
import { doubtsAndExit } from './doubtsAndExit';
import { fixedFooter } from './fixedFooter';
import { integratedSolutionCard } from './integratedSolutionCard';
import { logo } from './logo';
import { logoBcp } from './logoBcp';
import { membershipCompletionTitle } from './membershipCompletionTitle';
import { modals } from './modals';
import { planCards } from './planCards';
import { promotionalCode } from './promotionalCode';
import { requestContact } from './requestContact';
import { serviceError } from './serviceError';
import { summaryNextSteps } from './summaryNextSteps';
import { titleDocumentTermsCondition } from './titleDocumentTermsCondition';
import { titleResumeAndAuthorization } from './titleResumeAndAuthorization';
import { wizardMenu } from './wizardMenu';
import { changeEmail } from './changeEmail';
import { enterpriseSolution } from './enterpriseSolution';
import { membershipCompletionEnterpriseSolution } from './membershipCompletionEnterpriseSolution';
import { introWizard } from './introWizard';
import { intro } from './intro';
import { personalAccidentInsurance } from './personalAccidentInsurance';
import { establishmentAssistanceInsurance } from './establishmentAssistanceInsurance';

export const placeholders = {
	accountSelector,
	availableAccountList,
	accountSelected,
	bankDocument,
	cloudwareDocument,
	cloudwareDocumentDisclaimer,
	costSummary,
	doubtsAndExit,
	fixedFooter,
	integratedSolutionCard,
	logo,
	membershipCompletionTitle,
	planCards,
	promotionalCode,
	serviceError,
	summaryNextSteps,
	wizardMenu,
	authenticatorFooter,
	modals,
	logoBcp,
	requestContact,
	titleDocumentTermsCondition,
	titleResumeAndAuthorization,
	changeEmail,
	enterpriseSolution,
	membershipCompletionEnterpriseSolution,
	introWizard,
	intro,
	personalAccidentInsurance,
	establishmentAssistanceInsurance,
};
